import { fetchApi, getUserId } from 'shared/functions';

export const contactBoxService = ({ subject, message, origin, type, target }) => {
  const userId = getUserId();

  const resourceUrl = `/storefront/users/${userId}/${type}`;

  const params = {
    method: 'POST',
    body: JSON.stringify({ subject, message, origin, target }),
  };

  return fetchApi(resourceUrl, params);
};
